import React from "react";
import MainImage from "../../assets/HeroImages/MainPot11.jpg";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import PastWork from "../../components/PastWord";
import About from "../../components/About";
import Testimony from "../../components/Testimony";

function AuthorityAmplifier() {
  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F7F3F2]">
      <title>Authority Amplifier™ | Become a Trusted Voice in Your Niche | Her Growth Co.</title>
      <meta
        name="description"
        content="The Authority Amplifier program helps women-led brands build visibility, trust, and credibility through content and SEO strategy."
      />
      <meta
        name="keywords"
        content="all-in-one web design and seo austin, done-for-you digital marketing austin, texas authority builder package, full-service seo and design, complete branding and web package, web design + seo + cro bundle, authority website package for women, female founder digital growth system, expert web growth strategy austin, seo and website design for scaling, premium online presence package, growth marketing for women-led brands, texas personal brand digital services, scalable online authority system, web design and marketing austin, premium client attraction package, web services for premium consultants, high-ticket offer website funnel, all-in-one solution for experts, austin digital authority launchpad, niche domination digital package, entrepreneur website builder bundle, content + seo + design bundle, premium digital brand system texas, elite seo and branding solution, build online authority fast, amplify your brand voice, content marketing for coaches, thought leadership for consultants, visibility strategy for women-led brands, SEO + content for experts, digital power-up for founders, austin web design for women entrepreneurs, austin seo for female founders, website design for women-led businesses austin, custom websites for austin consultants, high-end website design austin, seo expert for women austin, premium branding austin women, austin digital authority launchpad, conversion-focused web design austin, web strategy for coaches austin, female entrepreneur seo services austin, austin cro expert services, all-in-one solution for experts, content marketing for women-led startups austin, seo for consultants in austin, website design agency austin tx, high-ticket client attraction austin, bespoke web design austin tx, online visibility for women founders, premium digital services austin, seo agency for women-owned business austin, women in business marketing austin, personal brand websites austin tx, social media + web strategy austin, website design for thought leaders austin"
      />

      <section className="bg-[#F7F3F2]">
        <div
          className="relative h-auto bg-cover bg-top"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${MainImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
          <Navbar />
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex items-center justify-center">
              <h1 className="text-black italic text-3xl max-w-96 bg-[#CFF098] font-semibold">The Authority Amplifier</h1>
            </div>
          </div>
        </div>

        <section className="bg-[#F7F3F2]">
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex flex-col items-center text-center">
              <h2 className="text-3xl font-regular md:text-5xl text-black max-w-7xl uppercase">
                Ready to Become the Leading Authority in Your Niche? Amplify Your Impact and Attract Premium Clients.
              </h2>
              <p className="mb-8 mt-4 max-w-4xl text-base text-black md:mb-12 md:text-lg font-light">
                For visionary <strong>women entrepreneurs</strong> ready to invest in a powerful, high-end online presence that positions them as industry leaders and consistently attracts premium clientele.
              </p>
            </div>

            {/* Benefits Grid Styled Like Services.jsx */}
            <div className="mt-12">
              <div className="grid gap-5 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:gap-4">
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">A Bespoke, High-Authority Website (Up to 12 Pages)</h3>
                  <p className="text-black text-base font-light">
                    Fully customized and uniquely tailored to your brand with advanced interactive elements and potential custom graphics or illustrations that elevate your online identity.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Become Unmissable Online</h3>
                  <p className="text-black text-base font-light">
                    A comprehensive SEO strategy covering local (Austin) and niche-specific keywords. Includes Google My Business optimization, local citations, and outreach link-building.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Maximize Your Conversions</h3>
                  <p className="text-black text-base font-light">
                    CRO strategies like A/B testing, optimized landing pages, and smart lead nurturing turn your visitors into high-value clients.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Establish Yourself as the Expert</h3>
                  <p className="text-black text-base font-light">
                    A content marketing blueprint plus initial blog posts or downloadable lead magnets designed to grow your audience and demonstrate your authority.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Seamless Social Integration</h3>
                  <p className="text-black text-base font-light">
                    Integrated social media links and share features to expand your visibility and influence across platforms.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Dedicated Support & Post-Launch Success</h3>
                  <p className="text-black text-base font-light">
                    A dedicated project manager, training on site management, and ongoing support ensure a smooth process and long-term success.
                  </p>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="flex flex-col items-center justify-center mt-16">
              <a href="/contact" className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black uppercase">
                SCHEDULE A PREMIUM STRATEGY CALL
              </a>
              <p className="text-black text-lg font-light mt-6 w-[400px] text-center">
                Invest in Your Authority. Let's Amplify Your Impact and Attract Your Ideal Clients!
              </p>
            </div>
          </div>
        </section>
        <PastWork />
        <Testimony/>
         <div className="bg-[#2E2D2B]"><About/></div>
        <Footer />
      </section>
    </main>
  );
}

export default AuthorityAmplifier;
